import apiHttpClient from "./ApiHttpClient";

export default class CompanyChapterSlideRepository {
  /**
   * createStudyHistory
   * @param {int} chapterId
   * @param {int} slideId
   * @returns {Promise}
   */
  async createStudyHistory(chapterId, slideId) {
    try {
      const res = await apiHttpClient.post(
        `/company_chapters/${chapterId}/slide/${slideId}`
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * updateStudyHistory
   * @param {int} chapterId
   * @param {int} slideId
   * @param {object} params
   */
  async updateStudyHistory(chapterId, slideId, params) {
    try {
      const res = await apiHttpClient.patch(
        `/company_chapters/${chapterId}/slide/${slideId}`,
        {
          id: params.id,
          startPage: params.startPage,
          endPage: params.endPage,
          timerInSecond: params.timerValue,
        }
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * slideComplete
   * @param {int} chapterId
   * @param {int} id
   * @param {int} timerValue
   * @returns {Promise}
   */
  async slideComplete(chapterId, id, timerValue) {
    try {
      const res = await apiHttpClient.post(
        `/company_courses/${chapterId}/slide/complete`,
        {
          id: id,
          timerInSecond: timerValue,
        }
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }
}
